import React from "react";

import { getLanguageTitle } from "application/helpers/string";
import { SupportedLanguages } from "integration/api/models";

import { Container } from "./styles";
import { RadioButton } from "application/components";

interface Props {
  checked: boolean;
  lng: SupportedLanguages;
  setLanguage: (lng: SupportedLanguages) => void;
}

const ReplyLanguage = ({ lng, checked, setLanguage }: Props) => {
  const id = `questionLng-${lng}`;

  const handlePress = (e: unknown) => {
    setLanguage(lng);
  };

  return (
    <Container disabled={checked} onClick={handlePress}>
      <RadioButton id={id} label={getLanguageTitle(lng)} checked={checked} onChange={handlePress} />
    </Container>
  );
};

export default ReplyLanguage;
